import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement("g", { fill: "currentColor" }, /* @__PURE__ */ React.createElement("path", { d: "M16.942 19.657a8 8 0 0 1-8.466 1.833l-.269-.1a2 2 0 0 1-.712-3.287l1.39-1.39a2 2 0 0 1 2.828 0l.672.672a2 2 0 0 0 2.828 0l2.172-2.172a2 2 0 0 0 0-2.828l-.672-.672a2 2 0 0 1 0-2.828l1.39-1.39a2 2 0 0 1 3.287.712l.1.269a8 8 0 0 1-1.833 8.466z" }), /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M4.592 4.592a1 1 0 0 0 0 1.414L8.885 10.3H5.3a1 1 0 1 0 0 2h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-2 0v3.586L6.006 4.592a1 1 0 0 0-1.414 0",
      clipRule: "evenodd"
    }
  ))
);
var SvgInboundFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var InboundFilled_default = SvgInboundFilled;

export { InboundFilled_default as default };
